module.exports = __webpack_public_path__ + "img/splashtop-logo.4869f537.svg";